import React from "react";

// Extracted verbatim from LandingPage.jsx (lines 142-235) — shared by LandingPage.jsx and
// CommonPaymentPage.jsx so neither keeps its own copy.
const ErrorModal = ({ show, message, onClose, title = "Error", onRetry = null }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.5)",
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "12px",
          padding: "24px",
          maxWidth: "400px",
          width: "100%",
          boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            fontSize: "18px",
            fontWeight: 600,
            color: "#ff3d00",
            marginBottom: "12px",
          }}
        >
          {title}
        </div>
        <div
          style={{
            fontSize: "14px",
            color: "#333",
            marginBottom: "20px",
            lineHeight: 1.5,
          }}
        >
          {message}
        </div>
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          {onRetry && (
            <button
              onClick={onRetry}
              style={{
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "6px",
                padding: "10px 24px",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
            >
              Retry Payment
            </button>
          )}
          <button
            onClick={onClose}
            style={{
              backgroundColor: "#f57c00",
              color: "white",
              border: "none",
              borderRadius: "6px",
              padding: "10px 24px",
              fontSize: "14px",
              fontWeight: 500,
              cursor: "pointer",
              transition: "background-color 0.2s",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#e65100")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#f57c00")}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
